import { ROUTE_PUBLIC_NARRATIVE_EDIT } from '@/constants/routes';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { getPath } from '@/router/utils';
import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';

import { useEffect } from 'react';
import { replace } from 'redux-first-router';

export const USE_EXISTING_NARRATIVE_REDIRECT_COMPANY_FRAGMENT = gql(`
  fragment UseExistingNarrativeRedirectCompanyFields on Company @_unmask {
    id
    myNarrative {
      id
    }
  }
`);

type Props = {
  company:
    | FragmentOf<typeof USE_EXISTING_NARRATIVE_REDIRECT_COMPANY_FRAGMENT>
    | undefined;
};

/**
 * Takes a user to the existing narrative edit page if the user already created a narrative for this company
 */
export const useExistingNarrativeRedirect = ({ company }: Props) => {
  const { getItem } = useQueryStringParam();
  const { myNarrative, id: companyId } = company ?? {};
  const userNarrativeId = myNarrative?.id;

  const returnPath = getItem('returnPath');
  useEffect(() => {
    if (!companyId || !userNarrativeId) return;

    replace(
      getPath({
        type: ROUTE_PUBLIC_NARRATIVE_EDIT,
        payload: { id: userNarrativeId },
        query: returnPath
          ? {
              company: companyId,
              returnPath,
            }
          : {},
      })
    );
  }, [userNarrativeId, companyId, returnPath]);
};
